<footer
  class="organizer-shared-navigation-buttons container"
  [ngClass]="footerClass"
>
  <nav class="col-span-12 flex items-center py-3 md:col-span-5 md:col-start-2">
    <a
      *ngIf="hasPreviousButton"
      app-vtmn-play-button
      class="mr-auto"
      [variant]="vtmnPlayButtonVariant"
      [style]="prevVariantStyle"
      [shape]="vtmnPlayButtonShape.SQUARED"
      [variant]="vtmnPlayButtonVariant.SECONDARY"
      [routerLink]="previousRouterLink"
      [queryParams]="previousQueryParameters"
      [queryParamsHandling]="previousQueryParametersHandling"
    >
      {{ 'shared_organizer.navigation.back' | translate }}
    </a>
    <a
      *ngIf="isPreventStep"
      app-vtmn-play-button
      class="mr-3"
      [routerLink]="previousRouterLink"
      [variant]="vtmnPlayButtonVariant.SECONDARY"
      [shape]="vtmnPlayButtonShape.SQUARED"
      (click)="skipTutorial()"
      data-test="creation-skip"
    >
      {{ 'shared_organizer.navigation.skip' | translate }}
    </a>
    <app-navigation-button
      [disabled]="nextDisabled"
      [hasEmit]="hasNextEmit"
      [isSubmit]="nextSubmit"
      [routerLinkButton]="nextRouterLink"
      [queryParameters]="nextQueryParameters"
      [queryParametersHandling]="nextQueryParametersHandling"
      [variant]="nextVariant"
      [shape]="vtmnPlayButtonShape.SQUARED"
      (click)="nextButtonClick()"
    >
      {{ nextLabel || ('shared_organizer.navigation.next' | translate) }}
    </app-navigation-button>
  </nav>
</footer>
